module.exports = __webpack_public_path__ + "img/artificial-intelligence-ai-chip-icon.882f1abd.svg";